import { render, staticRenderFns } from "./UploadVerificacion.vue?vue&type=template&id=400db013&scoped=true"
import script from "./UploadVerificacion.vue?vue&type=script&lang=js"
export * from "./UploadVerificacion.vue?vue&type=script&lang=js"
import style0 from "./UploadVerificacion.vue?vue&type=style&index=0&id=400db013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400db013",
  null
  
)

export default component.exports